import React, { Fragment, useEffect, useState, useRef } from 'react';
import Spinner from '../layouts/Spinner';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import { formattedDate, truncateObjectId } from '../../Utils/Common';
import {
    getDownloads,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    confirmDeleteDialogBoxDownload,
    setModal,
    generateReport,
} from '../../redux/actions/reports/reports.actions';
import { Redirect, useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import MUIDataTable from 'mui-datatables';
import {
    createMuiTheme,
    MuiThemeProvider,
    withStyles,
} from '@material-ui/core/styles';
import { Show, useAccess } from 'react-redux-permission';
import { Link } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import {
    handleHover,
    setMUIPage,
    updateMUISetting,
} from '../../redux/actions/helper/helper.actions';
import moment from 'moment';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import ReportGenerate from './modals/Report.generate';

function Downloads({
    report: {
        downloads,
        pagination,
        download_search,
        loading,
        edit_url,
        edit_page,
        create_url,
        sort_order_name,
        sort_order_direction,
        set_row_checked,
    },
    getDownloads,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    confirmDeleteDialogBoxDownload,
    hoverIndex,
    handleHover,
    updateMUISetting,
    setMUIPage,
    muiPage,
    setModal,
    generateReport,
}) {
    const { hasPermission } = useAccess();
    const canCreate = true;
    const canDelete = true;
    const canEdit = true;
    const canview = true;

    const history = useHistory();

    useEffect(() => {
        getDownloads(muiPage);
    }, []);

    // START DEVOUNCED SEARCH
    const debouncedSearch = useDebounce(download_search, 800);
    const [oldDebounced, setOldDebounced] = useState('');
    useEffect(() => {
        if (debouncedSearch) {
            if (oldDebounced !== debouncedSearch[0]) {
                if (debouncedSearch[0].length !== 1) {
                    setOldDebounced(debouncedSearch[0]);
                    getDownloads(1);
                }
            }
        }
    }, [debouncedSearch]);
    // END DEVOUNCE SEARCH

    const [copiedId, setCopiedId] = useState(null);

    if (edit_page) return <Redirect to={edit_url} />;

    const changePage = (link) => {
        history.push(link);
    };

    const getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MUIDataTable: {
                    root: {},
                    paper: {
                        boxShadow: 'none',
                    },
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: 'rgba(0,0,0,.05)',
                        },
                    },
                },
                MuiTableRow: {
                    hover: {
                        '&:hover': {
                            backgroundColor: '#bfcfe4 !important',
                        },
                    },
                },
                MUIDataTableBodyCell: {
                    root: {
                        '&:nth-child(6)': {
                            height: '61px',
                        },
                    },
                },
                MUIDataTableHeadCell: {
                    root: {
                        '&:nth-child(3)': {
                            width: '250px',
                        },
                        '&:nth-child(6)': {
                            width: '150px',
                        },
                    },
                },
            },
        });

    const columns = [
        {
            name: '_id',
            label: '',
            options: {
                display: false,
                viewColumns: false,
                filter: false,
                print: false,
                download: false,
            },
        },
        {
            name: 'created_at',
            label: 'Date Generated',
            options: {
                display: true,
                customBodyRender: (value) => {
                    return <span> {value.substr(0, 10)} </span>;
                },
                setCellProps: (value) => {
                    return { className: 'cursor-pointer' };
                },
            },
        },
        {
            name: 'report_name',
            label: 'Report Name',
            options: { display: true },
        },
        {
            name: 'generated_by',
            label: 'Generated by',
            options: { display: true },
        },
        {
            name: '',
            label: '',
            options: {
                display: true,
                filter: false,
                sort: false,
                print: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let fileUrl = downloads[tableMeta['rowIndex']].filePath;

                    const handleDownloadCSV = () => {
                        if (fileUrl) {
                            window.open(fileUrl, '_blank');
                        }
                    };

                    return (
                        <div className="btn-group" style={{ minWidth: '50px' }}>
                            {hoverIndex === tableMeta.rowIndex && (
                                <button
                                    className="btn btn-sm btn-blue"
                                    onClick={handleDownloadCSV}
                                >
                                    Download
                                </button>
                            )}
                        </div>
                    );
                },
                setCellProps: (value) => {
                    return { className: 'text-center' };
                },
            },
        },
    ];

    const options = {
        serverSide: true,
        jumpToPage: true,
        filterType: 'dropdown',
        responsive: 'standard',
        rowsPerPageOptions: [10, 20],
        rowsPerPage: pagination.itemsCountPerPage,
        count: pagination.totalItemsCount,
        page: pagination.activePage - 1,
        search: false,
        searchOpen: true,
        elevation: 2,
        filter: false,
        sortOrder: {
            name: sort_order_name,
            direction: sort_order_direction,
        },
        downloadOptions: {
            filename: `report_downloads_${formattedDate()}.csv`,
        },
        textLabels: {
            body: {
                noMatch: loading ? (
                    <Spinner />
                ) : (
                    'Sorry, there is no matching data to display'
                ),
            },
        },
        onChangeRowsPerPage: (numberOfRows) => {
            getDownloads(null, numberOfRows);
            updateMUISetting('rows', 'report', numberOfRows);
        },
        onTableChange: (action, tableState) => {
            // console.log(action, tableState);
            switch (action) {
                case 'changePage':
                    getDownloads(
                        tableState.page + 1,
                        pagination.itemsCountPerPage
                    );
                    setMUIPage(tableState.page + 1);
                    break;
                case 'sort':
                    // console.log(tableState.sortOrder.name, tableState.sortOrder.direction);
                    let column_name = tableState.sortOrder.name;
                    let direction = tableState.sortOrder.direction;
                    sortTableByColumn(column_name, direction);
                    break;
                case 'search':
                    // handleSearchInputMUI(tableState.searchText);
                    break;
                case 'rowSelectionChange':
                    let selectedRows = tableState.selectedRows.data;
                    let currentRows = tableState.data;
                    getSelectedRows(selectedRows, currentRows);
                    break;
                case 'propsUpdate':
                    // let update_checked = tableState.selectedRows = { data: [], lookup: {}, showResponsive: false };
                    if (set_row_checked) {
                        tableState.selectedRows['data'] = [];
                        tableState.selectedRows['lookup'] = {};
                        tableState.selectedRows['showResponsive'] = false;
                    } else {
                        return tableState;
                    }
                case 'viewColumnsChange':
                    updateMUISetting(
                        'columns',
                        'report',
                        null,
                        tableState.columns
                    );
                    break;
                default:
                    console.log('action not handled.');
            }
        },
        onRowsDelete: () => {
            // Confirm Delete Modal
            if (canDelete) {
                confirmDeleteDialogBoxDownload();
            }

            return false;
        },
        onRowClick: (rowData, rowMeta) => {
            // Go to edit page when row is clicked
            if (canEdit) {
                // changePage(`${edit_url}/${rowData[0]}`);
            }
        },
        customSearchRender: (searchText, handleSearch, hideSearch, options) => {
            return (
                <div className="custom-search">
                    <i className="ft ft-search"></i>{' '}
                    <input
                        type="text"
                        name="search"
                        value={download_search}
                        onChange={handleSearchInputMUI}
                        className="custom-search-input"
                    />
                </div>
            );
        },
        setRowProps: (data, dataIndex, rowIndex) => {
            return {
                onMouseEnter: () => handleHover('in', rowIndex),
                onMouseLeave: () => handleHover('out', rowIndex),
            };
        },
    };

    if (!canDelete) {
        options.selectableRows = false;
    }

    const _columns = updateMUISetting('view-columns', 'report', null, columns);

    return (
        <>
            {' '}
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">
                            Download Reports{' '}
                            <a
                                href="#"
                                className="tool-tip"
                                data-tip="this is a tool tip"
                            >
                                <i className="la la-question-circle"></i>
                            </a>
                            {/* <div className="pull-right">
                                <Show when="inv.inventory.reports.create">
                                    <Link
                                        to={create_url}
                                        className="btn btn-sm btn-primary text-white "
                                    >
                                        <i className="ft ft-plus"></i> Create
                                        New
                                    </Link>
                                </Show>
                            </div> */}
                        </h4>
                        <a className="heading-elements-toggle">
                            <i className="la la-ellipsis-v font-medium-3"></i>
                        </a>
                        <div className="heading-elements">
                            <ul className="list-inline mb-0"></ul>
                        </div>
                    </div>
                    <div className="card-content collapse show">
                        <div className="card-body">
                            <Show when="inv.inventory.reports.view">
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        data={downloads}
                                        columns={_columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                            </Show>
                        </div>
                    </div>
                </div>
            </div>
            <ReportGenerate
                className="modal-centered"
                onHide={() => setModal('generate_report', null)}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    report: state.report,
    hoverIndex: state.helper.hoverIndex,
    muiPage: state.helper.muiPage,
});

export default connect(mapStateToProps, {
    getDownloads,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    confirmDeleteDialogBoxDownload,
    handleHover,
    updateMUISetting,
    setMUIPage,
    setModal,
    generateReport,
})(Downloads);
